import { Route } from '../../route.model';
import LoyaltyTransaction from '@/views/Portal/LoyaltyTransaction.vue';

const portalLoyaltyTransaction = new Route(
  '/portal/loyalty-transaction/:connectTransactionId',
  'portal-loyalty-transaction',
  LoyaltyTransaction,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalLoyaltyTransaction };
export default portalLoyaltyTransaction;
